import React from 'react';
import styled from 'styled-components';

// Components
import { IconActionChevronLeft } from 'wg-fe-ui';
import LargeButton from './LargeButton';

interface Props {
  disabled?: boolean;
  onClick: (arg0: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children: React.ReactNode;
}

const BackButton: React.FC<React.PropsWithChildren<Props>> = ({
  disabled,
  onClick,
  children,
  ...rest
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      {...rest}
      data-test-id="ProdFac_BackButton"
    >
      <IconActionChevronLeft size="20" />
      {children}
    </Button>
  );
};

const Button = styled(LargeButton)<{ disabled?: boolean }>`
  background: none;
  padding: 1rem;
  color: ${({ theme }) => theme.gray[400]};
  display: flex;
  justify-content: center;
  width: unset;
  align-items: center;
  & > svg {
    path {
      stroke: ${({ theme }) => theme.gray[400]};
    }
  }
  :focus {
    outline: none;
  }

  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.gray[300]};
    background-color: transparent;
  }
`;

export default BackButton;
